import PrintableDocument from './PrintableDocument';

interface PrintablePrescriptionProps {
  patientName: string;
  practitionerName: string;
  practitionerTitle?: string;
  date: string;
  ordonnance: string;
  dureeTraitement?: string;
  instructions?: string;
  verificationUrl?: string;
  onReady?: () => void;
}

export default function PrintablePrescription({
  patientName,
  practitionerName,
  practitionerTitle,
  date,
  ordonnance,
  dureeTraitement,
  instructions,
  verificationUrl,
  onReady,
}: PrintablePrescriptionProps) {
  return (
    <PrintableDocument
      documentTitle="Ordonnance"
      patientName={patientName}
      practitionerName={practitionerName}
      practitionerTitle={practitionerTitle}
      date={date}
      verificationUrl={verificationUrl}
      letterhead
      onReady={onReady}
    >
      {/* Ordonnance */}
      <div className="print-section-title">
        <i className="ri-medicine-bottle-fill" style={{ marginRight: '6px', fontSize: '14px' }}></i>
        Prescription médicale
      </div>
      <div
        className="print-text"
        style={{
          marginBottom: '6mm',
          padding: '4mm',
          borderRadius: '4px',
          background: '#fafafa',
          minHeight: '80mm',
        }}
      >
        {ordonnance}
      </div>

      {/* Durée */}
      {dureeTraitement && (
        <div className="print-row" style={{ marginBottom: '4mm' }}>
          <div className="print-col">
            <span className="print-label">Durée du traitement :</span>{' '}
            <span className="print-text">{dureeTraitement}</span>
          </div>
        </div>
      )}

      {/* Instructions */}
      {instructions && (
        <>
          <div className="print-section-title">
            <i className="ri-information-fill" style={{ marginRight: '6px', fontSize: '14px' }}></i>
            Instructions particulières
          </div>
          <div className="print-text" style={{ marginBottom: '4mm' }}>{instructions}</div>
        </>
      )}

      {/* Signature */}
      <div style={{ marginTop: '12mm', textAlign: 'right' }}>
        <div style={{ fontSize: '10pt', color: '#666' }}>{practitionerName}</div>
        {practitionerTitle && <div style={{ fontSize: '9pt', color: '#999' }}>{practitionerTitle}</div>}
      </div>
    </PrintableDocument>
  );
}